// MST
import { types, flow, cast, detach } from 'mobx-state-tree';

// Interfaces
import {
  IAssessmentAdministrativeProofGetListAttrs,
} from 'interfaces/back-office/assessment/registration/administrative-proof/administrative-proof-view.interface';
import {
  IAssessmentAdministrativeProofApiListResponse,
} from 'interfaces/back-office/assessment/registration/administrative-proof/administrative-proof-api.interface';
import { ISharedCommonLoadingAttrs, ISharedCommonLoadingQuestionSetAttrs } from 'interfaces/shared/shared-common.interface';

// Extensions
import { withEnvironment } from 'models/extensions/with-environment';

// Utils
import {
  withHelper_questionSetModel,
  withHelper_commonLoadingModel,
  withHelper_commonMapLoading,
  withHelper_commonMapQuestionSet,
  withHelper_commonMapQuestionSetLoading,
} from 'models/extensions/helper';

// Constant
import { LOADING } from 'constant/shared.constant';

// Types
const { optional, model, array } = types;

// Loading
const { BASE } = LOADING;



// Base Model
const AssessmentAdministrativeProofStoreModel = model('AssessmentAdministrativeProof')
  .props({
    assessmentAdministrativeProof_loading: withHelper_commonLoadingModel,
    assessmentAdministrativeProof_data: optional(model('assessmentAdministrativeProofDataModel')
      .props({
        assessmentAdministrativeProof_list: optional(array(withHelper_questionSetModel), []),
      }), 
      {}
  ),
  })
  .actions(self => ({
    assessmentAdministrativeProof_SET_LOADING: (payload: ISharedCommonLoadingAttrs): void => {
      const map = withHelper_commonMapLoading(self.assessmentAdministrativeProof_loading, payload);

      detach(self.assessmentAdministrativeProof_loading);
      self.assessmentAdministrativeProof_loading = cast(map);
    },
    assessmentAdministrativeProof_SET_LIST: (payload: IAssessmentAdministrativeProofApiListResponse['res']['data']): void => {
      console.log(payload)
      const map = withHelper_commonMapQuestionSet(payload?.questionSet);
      // detach(self.assessmentAdministrativeProof_list);
      self.assessmentAdministrativeProof_data.assessmentAdministrativeProof_list = cast(map);
    },
    assessmentAdministrativeProof_MAP_LOADING_LIST: (payload: ISharedCommonLoadingQuestionSetAttrs): void => {
      const map = withHelper_commonMapQuestionSetLoading(self.assessmentAdministrativeProof_data.assessmentAdministrativeProof_list, payload);

      detach(self.assessmentAdministrativeProof_data.assessmentAdministrativeProof_list);
      self.assessmentAdministrativeProof_data.assessmentAdministrativeProof_list = cast(map);
    },
    assessmentAdministrativeProof_CLEAR_LIST: (): void => {
      self.assessmentAdministrativeProof_data.assessmentAdministrativeProof_list = cast([]);
    },
  }))
  .extend(withEnvironment)
  .actions(self => ({
    /**
     * @description Fetch assessment general proof list
     *
     * @param {IAssessmentAdministrativeProofGetListAttrs} payload
     *
     * @return {any} any
     */
    assessmentAdministrativeProof_fetchList: flow(function* (payload: IAssessmentAdministrativeProofGetListAttrs) {
      self.assessmentAdministrativeProof_SET_LOADING({ type: BASE, value: true });

      const response: IAssessmentAdministrativeProofApiListResponse =
        yield self.environment.assessmentAdministrativeProofApi.assessmentAdministrativeProof_getList({
          params: { ...payload.params },
          requestConfig: { ...payload.requestConfig },
        });

      if (response.ok) {
        self.assessmentAdministrativeProof_SET_LIST(response.res.data);

        if (payload?.onSuccess) payload.onSuccess();
      }

      if (!response.ok) {
        if (payload?.onError) payload.onError();
      }

      self.assessmentAdministrativeProof_SET_LOADING({ type: BASE, value: false });
    }),
  }));

export const createAssessmentAdministrativeProofStoreDefaultModel = () => optional(AssessmentAdministrativeProofStoreModel, {});
